import { Pipe, PipeTransform } from '@angular/core';
import { appConfig } from 'src/app/config/app.config';
import { UtilityTs } from 'src/app/util/utilityTs';

@Pipe({
    name: 'sorting'
})
export class SortingPipe implements PipeTransform {

    transform(value: any[], type: string, key?: string, reverse?: boolean) {
        switch (type) {
            case "stringArray": UtilityTs.sortString(value, reverse); break;
            case "numberArray": UtilityTs.sortNumberArray(value, reverse); break;
            case "objArrayString": UtilityTs.sortStringInObject(value, key, reverse); break;
            case "objArrayNumber": UtilityTs.sortNumberInObject(value, key, reverse); break;
        }

        return value;
    }

}
